import Grid from '@mui/material/Grid/Grid';
import {Product} from  "../../app/models/product";
import { useAppSelector } from '../../app/store/configStore';
import ProductCard from './ProductCard';
import ProductCardSkeleton from './ProductCardSkeleton';

interface Props {
    products: Product[];
}


export default function ProductList({products}: Props){
    const {productsLoaded} = useAppSelector(state => state.catalog);
    return (<Grid container spacing={6}>
    {products.map(product => (
        <Grid item xs={12} sm={6} md={4} key= {product.id}>
            {!productsLoaded ? (
                <ProductCardSkeleton/>
            ): (
                <ProductCard product={product}/>
            )}
        </Grid>
        ))}
        </Grid>)
}